<div class="card">
  <div class="fidelity-info-container">
    <div class="fidelity-info-title-container">
      <div class="fidelity-info-title title">
        <span>
          {{ 'fidelity-info.header' | translate }}
        </span>
      </div>
      <button class="fidelity-close close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-return" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-return"></use>
          </svg>
        </span>
      </button>
    </div>

    @if (!currentCustomer.fidelity) {
      <div class="fidelity-skeleton">
        <div class="fidelity-info fidelity-section">
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <div class="fidelity-info-data">
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
          </div>
        </div>
        <div class="fidelity-points fidelity-section">
          <div class="fidelity-points-title title">
            {{ 'fidelity-info.my-points' | translate }}
          </div>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
        <div class="fidelity-rewards fidelity-section">
          <div class="fidelity-rewards-title title" [innerHtml]="'fidelity-info.my-rewards' | translate"></div>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
      </div>
    } @else {
      @if (currentCustomer.fidelity) {
        <div class="fidelity-info fidelity-section">
          <div class="fidelity-info-header">
            <div class="fidelity-card-info">
              @if (isActive) {
                <div class="fidelity-common-label fidelity-yellow">
                  {{ 'fidelity-info.active' | translate : { date: dateToString(currentCustomer.fidelity.createdDate) } }}
                </div>
              }
              <div class="fidelity-card-name title">
                {{ currentCustomer?.fidelity?.typeCard | fidelityCardTypeName | translate }}
              </div>
            </div>
            <div class="fidelity-card-img">
              <img src="assets/img/kitchen/identification/Carte_Castorama.svg" />
            </div>
          </div>
          <div class="fidelity-info-data">
            <div
              class="fidelity-common-label fidelity-info-label"
              [innerHtml]="
                'fidelity-info.card-number' | translate: { number: currentCustomer.fidelity.cardNumber }
              "></div>

            @if (currentCustomer.fidelity.createdDate) {
              <div
                class="fidelity-common-label fidelity-info-label"
                [innerHtml]="'fidelity-info.created' | translate: { date: dateToString(currentCustomer.fidelity.createdDate) }"></div>
            }

            @if (currentCustomer.fidelity?.expiredDate) {
              <div
                class="fidelity-common-label fidelity-info-label"
                [innerHtml]="'fidelity-info.expire' | translate: { date: dateToString(currentCustomer.fidelity.expiredDate) }"></div>
            }
          </div>
        </div>
        @if (isActive) {
          <div class="fidelity-points fidelity-section">
            <div class="fidelity-points-title title">
              {{ 'fidelity-info.my-points' | translate }}
            </div>
            @if (currentCustomer.fidelity.points) {
              <div class="fidelity-points-slider">
                <div class="fidelity-points-minmax">
                  <div class="min">
                    {{ 'fidelity-info.points' | translate: { point: minPointValue, s: '' } }}
                  </div>
                  <div class="max">
                    {{ 'fidelity-info.points' | translate: { point: currentCustomer.fidelity.maxPoints, s: 's' } }}
                  </div>
                </div>
                <p-slider
                  [(ngModel)]="currentCustomer.fidelity.points"
                  [min]="minPointValue"
                  [max]="currentCustomer.fidelity.maxPoints"
                  [animate]="true"
                  [styleClass]="'point-slider'"
                  [disabled]="true" />

                <div
                  class="fidelity-slider-label fidelity-common-label fidelity-yellow-small"
                  [style.margin-left.%]="getSliderPosition()">
                  <div class="max">
                    {{
                      'fidelity-info.points' | translate: {
                        point: currentCustomer.fidelity.points,
                        s: currentCustomer.fidelity.points > 1 ? 's' : ''
                      }
                    }}
                  </div>
                </div>
              </div>
            } @else {
              <span class="no-data" [innerHtml]="'fidelity-info.no-point-data' | translate"></span>
            }
          </div>
          <div class="fidelity-rewards fidelity-section">
            <div class="fidelity-rewards-title title" [innerHtml]="'fidelity-info.my-rewards' | translate"></div>
            <div class="fidelity-rewards-list">
              @if (currentCustomer.fidelity.coupons.offerCouponsList.length > 0) {
                <div class="rewards-list">
                  @for (offerCoupon of currentCustomer.fidelity.coupons.offerCouponsList; track offerCoupon) {
                    <ng-casto-offer-coupon-card
                      [title]="offerCoupon.name"
                      [expirationDate]="offerCoupon.usabilityEndDate"></ng-casto-offer-coupon-card>
                  }
                </div>
              } @else {
                <span class="no-offer" [innerHTML]="'fidelity-info.no-offer'|translate"></span>
              }
            </div>
          </div>
        }
      } @else {
        <span class="no-data" [innerHtml]="'fidelity-info.no-data' | translate"></span>
      }
    }
  </div>
</div>
